<div class="dialog-content">
  <div class="main">
    <app-onboarding [itemData]="data"></app-onboarding>
  </div>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
